import Buttons from "../../../components/UI/Buttons";
import SectionLoader from "../../../components/UI/SectionLoader";
import { encryptString } from "../../../utils/commonUtils";

const DrugScreen = (props) => {
    const { data, filter, isLoading } = props;
    const { drug_screen } = data;
    const { company_id, clinic_id } = filter;
    const filterParams = encryptString({
        visit_category: 'Employer Services - Drug Screens',
        company_id: company_id || '',
        clinic_id: clinic_id || '',
    });
    return (
        <div className="col-md-4 col-12 mb-2 pb-1">
            <div class="d-flex  align-items-top w-100 sh_newdashcard mintgreen">
                <div class="d-flex flex-column  w-100">
                    <h1 class="p1-strong mb-2">Drug Screens</h1>
                    <div class="d-flex justify-content-between">
                        <p class="p3-light text-dark mb-1">
                            <span class="mr-1">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="12" height="12" rx="6" fill="#7D4BC5"></rect>
                                </svg>
                            </span>
                            Negative</p>
                        <p class="p3-light text-dark mb-1">{drug_screen?.negative_percentage || 0}%</p>
                    </div>
                    <div class="d-flex justify-content-between">
                        <p class="p3-light text-dark mb-1">
                            <span class="mr-1">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="12" height="12" rx="6" fill="#F6447E"></rect>
                                </svg>
                            </span>
                            Pending</p>
                        <p class="p3-light text-dark mb-1">{drug_screen?.pending_percentage || 0}%</p>
                    </div>

                </div>
                <div class="w-100 d-flex justify-content-center">

                    <svg id="donutSvg" width="100" height="100" viewBox="0 0 136 136" stroke-width="6">
                        <circle class="bg" cx="68" cy="68" r="65" stroke="#f2f2f2" fill="none"></circle>

                        <circle id="seg1" class="sh_donutsegment" cx="68" cy="68" r="65" stroke="#7D4BC5" fill="none"></circle>
                        <circle id="seg2" class="sh_donutsegment" cx="68" cy="68" r="65" stroke="#F6447E" fill="none"></circle>

                        <g class="iconGroup" fill="transparent" transform="translate(50 50)">
                            <circle cx="14.1645" cy="14.6645" r="4.1684" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></circle>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M28.93 23.4183L22.9158 29.4324C21.4852 30.863 19.1676 30.863 17.737 29.4324V29.4324C16.3064 28.0019 16.3064 25.6842 17.737 24.2536L23.7512 18.2395C25.1818 16.8089 27.4994 16.8089 28.93 18.2395V18.2395C30.3623 19.67 30.3623 21.9877 28.93 23.4183Z" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M20.7617 21.2637L25.9055 26.4091" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M28.3352 35.5066H11.6616C7.97843 35.5066 4.99219 32.5204 4.99219 28.8372V12.1636C4.99219 8.48038 7.97843 5.49414 11.6616 5.49414H28.3352C32.0184 5.49414 35.0047 8.48038 35.0047 12.1636V28.8372C35.0047 32.5204 32.0184 35.5066 28.3352 35.5066Z" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    );
}
export default DrugScreen;